/**
 * OfflineIndicator Component
 * 
 * Shows when app is offline with queue count
 */

import { useEffect, useState } from 'react';
import { useRiderStore } from '@/store/rider';
import { syncQueue } from '@/lib/syncQueue';

export default function OfflineIndicator() {
  const isOnline = useRiderStore((state) => state.isOnline);
  const [queueCount, setQueueCount] = useState(0);

  useEffect(() => {
    const updateQueueCount = async () => {
      const count = await syncQueue.getCount();
      setQueueCount(count);
    };

    // Update immediately
    updateQueueCount();

    // Update periodically
    const interval = setInterval(updateQueueCount, 2000);

    return () => clearInterval(interval);
  }, []);

  if (isOnline && queueCount === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-20 left-4 right-4 z-50">
      <div className={`rounded-lg p-3 shadow-lg flex items-center gap-3 ${
        isOnline
          ? 'bg-orange-100 border border-orange-200'
          : 'bg-red-100 border border-red-200'
      }`}>
        <div className={`w-2 h-2 rounded-full ${
          isOnline ? 'bg-orange-500' : 'bg-red-500'
        } animate-pulse`} />
        
        <div className="flex-1">
          <div className={`text-sm font-medium ${
            isOnline ? 'text-orange-900' : 'text-red-900'
          }`}>
            {isOnline ? 'Syncing...' : 'Offline Mode'}
          </div>
          {queueCount > 0 && (
            <div className={`text-xs ${
              isOnline ? 'text-orange-700' : 'text-red-700'
            }`}>
              {queueCount} {queueCount === 1 ? 'action' : 'actions'} pending
            </div>
          )}
        </div>

        {queueCount > 0 && (
          <div className={`text-lg font-bold ${
            isOnline ? 'text-orange-600' : 'text-red-600'
          }`}>
            {queueCount}
          </div>
        )}
      </div>
    </div>
  );
}


















